<section class="assistant-store-page" testId="official-assistant-store-page">
  <div class="page-topbar">
    <header class="page-header">
      <div>
        <h2>{{ 'assistant.store.title' | i18n }}</h2>
        <p>{{ 'assistant.store.subtitle' | i18n }}</p>
      </div>
      <div class="page-actions">
        <button nz-button nzType="primary" type="button" (click)="openCreateModal()" testId="official-assistant-store-create"
          ><i nz-icon nzType="plus"></i>{{ 'assistant.store.action.create' | i18n }}</button
        >
      </div>
    </header>
  </div>

  <div class="page-scroll">
    <nav class="store-tabs" [attr.aria-label]="'assistant.store.tabs.aria-label' | i18n">
      <button
        type="button"
        [class.is-active]="activeTab === 'templates'"
        (click)="selectTab('templates')"
        testId="official-assistant-store-tab-templates"
      >
        {{ 'assistant.store.tab.templates' | i18n }}
      </button>
      <button
        type="button"
        [class.is-active]="activeTab === 'operations'"
        (click)="selectTab('operations')"
        testId="official-assistant-store-tab-operations"
      >
        {{ 'assistant.store.tab.operations' | i18n }}
      </button>
    </nav>

    <ng-container *ngIf="activeTab === 'templates'; else operationsView">
      <div class="summary-grid">
        <div class="summary-item"
          ><i nz-icon nzType="robot"></i><span>{{ 'assistant.store.summary.total' | i18n }}</span
          ><strong>{{ apps.length }}</strong></div
        >
        <div class="summary-item"
          ><i nz-icon nzType="tag"></i><span>{{ 'assistant.store.status.published' | i18n }}</span
          ><strong>{{ getStatusCount('Published') }}</strong></div
        >
        <div class="summary-item"
          ><i nz-icon nzType="edit"></i><span>{{ 'assistant.store.status.draft' | i18n }}</span
          ><strong>{{ getStatusCount('Draft') }}</strong></div
        >
        <div class="summary-item"
          ><i nz-icon nzType="tag"></i><span>{{ 'assistant.store.status.unpublished' | i18n }}</span
          ><strong>{{ getStatusCount('Unpublished') }}</strong></div
        >
        <div class="summary-item" testId="assistant-store-active-subscribers"
          ><i nz-icon nzType="team"></i><span>{{ 'assistant.store.summary.active-subscribers' | i18n }}</span
          ><strong>{{ getActiveSubscriberCount() }}</strong></div
        >
      </div>

      <div class="filter-bar">
        <nz-input-group class="filter-search" [nzPrefix]="searchPrefix">
          <input
            nz-input
            [(ngModel)]="keyword"
            (ngModelChange)="applyFilters()"
            [placeholder]="'assistant.store.search.placeholder' | i18n"
            testId="official-assistant-store-search-input"
          />
        </nz-input-group>
        <ng-template #searchPrefix><i nz-icon nzType="search"></i></ng-template>
        <nz-select
          [(ngModel)]="statusFilter"
          (ngModelChange)="applyFilters()"
          [nzPlaceHolder]="'assistant.store.filter.status.all' | i18n"
          nzAllowClear
          testId="official-assistant-store-status-filter"
        >
          <nz-option nzValue="Draft" [nzLabel]="'assistant.store.status.draft' | i18n" /><nz-option
            nzValue="Published"
            [nzLabel]="'assistant.store.status.published' | i18n"
          /><nz-option nzValue="Unpublished" [nzLabel]="'assistant.store.status.unpublished' | i18n" />
        </nz-select>
        <nz-select
          [(ngModel)]="categoryFilter"
          (ngModelChange)="applyFilters()"
          [nzPlaceHolder]="'assistant.store.filter.category.all' | i18n"
          nzAllowClear
          testId="official-assistant-store-category-filter"
        >
          <nz-option *ngFor="let category of categories" [nzValue]="category" [nzLabel]="categoryLabel(category)" />
        </nz-select>
      </div>

      <nz-spin class="table-spin" [nzSpinning]="loading">
        <div class="table-wrap">
          <table class="assistant-table" *ngIf="filteredApps.length; else emptyState" testId="official-assistant-store-table">
            <thead>
              <tr>
                <th>{{ 'assistant.store.table.template' | i18n }}</th>
                <th>{{ 'assistant.store.table.provider' | i18n }}</th>
                <th>{{ 'assistant.store.table.category' | i18n }}</th>
                <th>{{ 'assistant.store.table.status' | i18n }}</th>
                <th>{{ 'assistant.store.table.version' | i18n }}</th>
                <th>{{ 'assistant.store.table.packages' | i18n }}</th>
                <th>{{ 'assistant.store.table.tags' | i18n }}</th>
                <th>{{ 'assistant.store.table.subscribers' | i18n }}</th>
                <th>{{ 'assistant.store.table.updated-at' | i18n }}</th>
                <th class="actions-column">{{ 'assistant.store.table.actions' | i18n }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let app of filteredApps; trackBy: trackById" [attr.data-testid]="'official-assistant-store-row-' + app.id">
                <td>
                  <div class="app-name">
                    <img *ngIf="app.iconUrl; else iconFallback" [src]="app.iconUrl" alt="" />
                    <ng-template #iconFallback>
                      <span class="app-icon-fallback" aria-hidden="true">{{ app.name.slice(0, 1) }}</span>
                    </ng-template>
                    <div>
                      <strong>{{ app.name }}</strong>
                      <span>{{ app.shortDescription || app.description }}</span>
                    </div>
                  </div>
                </td>
                <td class="app-provider">{{ app.providerName || ('assistant.store.provider.official' | i18n) }}</td>
                <td>{{ app.customCategory || categoryLabel(app.category) }}</td>
                <td>
                  <nz-tag [ngClass]="'status-' + app.status.toLowerCase()">{{ statusLabel(app.status) }}</nz-tag>
                </td>
                <td>v{{ app.version }}</td>
                <td class="package-days">{{ formatPackageDurations(app) }}</td>
                <td>
                  <span class="tag-list">
                    <nz-tag *ngFor="let tag of app.featureTags || []">{{ tag }}</nz-tag>
                  </span>
                </td>
                <td class="subscriber-count">{{ getSubscriberCount(app) }}</td>
                <td>{{ formatDate(app.updateTime) }}</td>
                <td class="actions">
                  <button
                    nz-button
                    nzSize="small"
                    type="button"
                    (click)="openEditModal(app)"
                    [testId]="'official-assistant-store-edit-button-' + app.id"
                  >
                    {{ 'assistant.store.action.edit' | i18n }}
                  </button>
                  <button
                    *ngIf="app.status !== 'Published'"
                    nz-button
                    nzSize="small"
                    class="publish-action"
                    type="button"
                    [nzLoading]="operatingId === app.id"
                    (click)="publish(app)"
                    [testId]="'official-assistant-store-publish-button-' + app.id"
                  >
                    {{ 'assistant.store.action.publish' | i18n }}
                  </button>
                  <button
                    *ngIf="app.status === 'Published'"
                    nz-button
                    nzSize="small"
                    nzDanger
                    type="button"
                    [nzLoading]="operatingId === app.id"
                    (click)="unpublish(app)"
                    [testId]="'official-assistant-store-unpublish-button-' + app.id"
                  >
                    {{ 'assistant.store.action.unpublish' | i18n }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <ng-template #emptyState>
            <nz-empty [nzNotFoundContent]="'assistant.store.empty.templates' | i18n">
              <button nz-button nzType="primary" (click)="openCreateModal()" testId="official-assistant-store-empty-create-button">
                {{ 'assistant.store.action.create' | i18n }}
              </button>
            </nz-empty>
          </ng-template>
        </div>
      </nz-spin>
    </ng-container>

    <ng-template #operationsView>
      <section class="operations-panel">
        <div class="operations-heading">
          <div>
            <h3>{{ 'assistant.store.operations.title' | i18n }}</h3>
            <p>{{ 'assistant.store.operations.subtitle' | i18n }}</p>
          </div>
          <div class="operations-actions">
            <span>{{
              operationsKpi?.lastUpdatedTime
                ? formatDate(operationsKpi?.lastUpdatedTime)
                : ('assistant.store.operations.refresh-note' | i18n)
            }}</span>
            <button
              nz-button
              nzType="text"
              type="button"
              [nzLoading]="operationsLoading"
              (click)="loadOperationsKpi()"
              testId="assistant-store-operations-refresh"
            >
              <i nz-icon nzType="reload"></i>
            </button>
          </div>
        </div>
        <div
          *ngIf="operationsLoading; else operationsSummaryData"
          class="operations-summary operations-summary-skeleton operations-skeleton"
          aria-hidden="true"
        >
          <div class="operations-summary-card" *ngFor="let item of operationsSkeletonCards">
            <span class="skeleton-block skeleton-summary-label"></span>
            <span class="skeleton-block skeleton-summary-value"></span>
            <span *ngIf="item === 2" class="skeleton-block skeleton-summary-hint"></span>
          </div>
        </div>
        <ng-template #operationsSummaryData>
          <div class="operations-summary" *ngIf="operationsKpi">
            <div class="operations-summary-card">
              <span>{{ 'assistant.store.operations.total-templates' | i18n }}</span>
              <strong>{{ operationsKpi.totalTemplateCount | number }}</strong>
            </div>
            <div class="operations-summary-card">
              <span>{{ 'assistant.store.operations.total-subscriptions' | i18n }}</span>
              <strong>{{ operationsKpi.totalSubscriptionCount | number }}</strong>
            </div>
            <div class="operations-summary-card">
              <span>{{ 'assistant.store.operations.active-subscriptions' | i18n }}</span>
              <strong>{{ operationsKpi.activeSubscriptionCount | number }}</strong>
              <small>{{ 'assistant.store.operations.active-subscriptions-hint' | i18n }}</small>
            </div>
            <div class="operations-summary-card">
              <span>{{ 'assistant.store.operations.gmv' | i18n }}</span>
              <strong>{{ formatMoney(operationsKpi.totalTransactionAmount) }}</strong>
            </div>
            <div class="operations-summary-card">
              <span>{{ 'assistant.store.operations.cash-revenue' | i18n }}</span>
              <strong>{{ formatMoney(operationsKpi.cashIncome) }}</strong>
            </div>
          </div>
        </ng-template>
        <div class="operations-filter-bar" [class.has-custom-dates]="operationsPeriod === 'custom'">
          <div class="operations-filter operations-filter-period">
            <span>{{ 'assistant.store.operations.filter.period' | i18n }}</span>
            <div class="operations-period-menu" (click)="$event.stopPropagation()">
              <button
                class="operations-period-trigger"
                type="button"
                [attr.aria-label]="'assistant.store.operations.filter.period' | i18n"
                aria-haspopup="listbox"
                [attr.aria-expanded]="operationsPeriodMenuOpen"
                (click)="toggleOperationsPeriodMenu($event)"
                (keydown.escape)="closeOperationsMenus()"
                testId="assistant-store-operations-period-trigger"
              >
                <span>{{ operationsPeriodLabelKey | i18n }}</span>
                <span class="operations-period-chevron" aria-hidden="true"></span>
              </button>
              <div
                class="operations-period-options"
                role="listbox"
                [attr.aria-label]="'assistant.store.operations.filter.period' | i18n"
                [hidden]="!operationsPeriodMenuOpen"
              >
                <button
                  *ngFor="let option of operationsPeriodOptions"
                  class="operations-period-option"
                  type="button"
                  role="option"
                  [class.is-selected]="option.value === operationsPeriod"
                  [attr.aria-selected]="option.value === operationsPeriod"
                  (click)="selectOperationsPeriod(option.value)"
                  [testId]="'assistant-store-operations-period-option-' + option.value"
                >
                  <span>{{ option.labelKey | i18n }}</span>
                  <span class="operations-period-check" aria-hidden="true">✓</span>
                </button>
              </div>
            </div>
          </div>
          <label *ngIf="operationsPeriod === 'custom'" class="operations-filter operations-filter-dates">
            <span>{{ 'assistant.store.operations.filter.date-range' | i18n }}</span>
            <nz-range-picker
              [(ngModel)]="operationsDateRange"
              (ngModelChange)="applyOperationsFilters()"
              testId="assistant-store-operations-date-range-picker"
            />
          </label>
          <div class="operations-filter operations-filter-category">
            <span>{{ 'assistant.store.operations.filter.category' | i18n }}</span>
            <div class="operations-category-menu" (click)="$event.stopPropagation()">
              <button
                class="operations-category-trigger"
                type="button"
                [attr.aria-label]="'assistant.store.operations.filter.category' | i18n"
                aria-haspopup="listbox"
                [attr.aria-expanded]="operationsCategoryMenuOpen"
                (click)="toggleOperationsCategoryMenu($event)"
                (keydown.escape)="closeOperationsMenus()"
                testId="assistant-store-operations-category-trigger"
              >
                <span>{{ operationsCategory ? categoryLabel(operationsCategory) : ('assistant.store.filter.category.all' | i18n) }}</span>
                <span class="operations-category-chevron" aria-hidden="true"></span>
              </button>
              <div
                class="operations-category-options"
                role="listbox"
                [attr.aria-label]="'assistant.store.operations.filter.category' | i18n"
                [hidden]="!operationsCategoryMenuOpen"
              >
                <button
                  class="operations-category-option"
                  type="button"
                  role="option"
                  [class.is-selected]="operationsCategory === null"
                  [attr.aria-selected]="operationsCategory === null"
                  (click)="selectOperationsCategory(null)"
                  testId="assistant-store-operations-category-option-all"
                >
                  <span>{{ 'assistant.store.filter.category.all' | i18n }}</span>
                  <span class="operations-category-check" aria-hidden="true">✓</span>
                </button>
                <button
                  *ngFor="let category of operationsCategories"
                  class="operations-category-option"
                  type="button"
                  role="option"
                  [class.is-selected]="category === operationsCategory"
                  [attr.aria-selected]="category === operationsCategory"
                  (click)="selectOperationsCategory(category)"
                  [testId]="'assistant-store-operations-category-option-' + category"
                >
                  <span>{{ categoryLabel(category) }}</span>
                  <span class="operations-category-check" aria-hidden="true">✓</span>
                </button>
              </div>
            </div>
          </div>
          <label class="operations-filter operations-filter-search">
            <span>{{ 'assistant.store.operations.filter.search-label' | i18n }}</span>
            <nz-input-group [nzPrefix]="operationsSearchPrefix">
              <input
                nz-input
                [(ngModel)]="operationsKeyword"
                (keyup.enter)="applyOperationsFilters()"
                [placeholder]="'assistant.store.operations.filter.search-placeholder' | i18n"
                testId="assistant-store-operations-keyword-input"
              />
            </nz-input-group>
            <ng-template #operationsSearchPrefix><i nz-icon nzType="search"></i></ng-template>
          </label>
        </div>
        <ng-container *ngIf="operationsLoading || operationsRows.length; else operationsEmpty">
          <div class="operations-table-wrap">
            <table
              class="operations-table"
              [class.operations-table-skeleton]="operationsLoading"
              [class.operations-skeleton]="operationsLoading"
              [attr.aria-busy]="operationsLoading"
            >
              <thead>
                <tr>
                  <th>{{ 'assistant.store.operations.name' | i18n }} <span class="sort-mark" aria-hidden="true">⇅</span></th>
                  <th>{{ 'assistant.store.operations.current-version' | i18n }} <span class="sort-mark" aria-hidden="true">⇅</span></th>
                  <th>{{ 'assistant.store.operations.total-subscriptions' | i18n }} <span class="sort-mark" aria-hidden="true">⇅</span></th>
                  <th
                    >{{ 'assistant.store.operations.active-subscriptions' | i18n }} <span class="sort-mark" aria-hidden="true">⇅</span></th
                  >
                  <th>{{ 'assistant.store.operations.gmv' | i18n }} <span class="sort-mark" aria-hidden="true">⇅</span></th>
                  <th>{{ 'assistant.store.operations.cash-revenue' | i18n }} <span class="sort-mark" aria-hidden="true">⇅</span></th>
                  <th>{{ 'assistant.store.operations.uupon-deduction' | i18n }} <span class="sort-mark" aria-hidden="true">⇅</span></th>
                </tr>
              </thead>
              <tbody *ngIf="operationsLoading" aria-hidden="true">
                <tr *ngFor="let row of operationsSkeletonRows">
                  <td *ngFor="let column of operationsSkeletonColumns">
                    <span class="skeleton-block skeleton-table-cell"></span>
                    <span *ngIf="column === 0" class="skeleton-block skeleton-table-subline"></span>
                  </td>
                </tr>
              </tbody>
              <tbody *ngIf="!operationsLoading">
                <tr *ngFor="let item of operationsRows">
                  <td class="operations-name"
                    ><strong>{{ item.name }}</strong
                    ><span>{{ categoryLabel(item.category) }}</span></td
                  >
                  <td class="operations-version">{{ item.version === '-' ? '-' : 'v' + item.version }}</td>
                  <td class="operations-number">{{ item.totalSubscriptions | number }}</td>
                  <td class="operations-number">{{ item.activeSubscriptions | number }}</td>
                  <td class="operations-money">{{ formatMoney(item.transactionAmount) }}</td>
                  <td class="operations-money">{{ formatMoney(item.cashIncome) }}</td>
                  <td class="operations-money">{{ item.uuponDeduction | number }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </ng-container>
        <ng-template #operationsEmpty
          ><div class="operations-empty"
            ><i nz-icon nzType="bar-chart"></i
            ><div
              ><strong>{{ 'assistant.store.operations.empty.title' | i18n }}</strong
              ><span>{{ 'assistant.store.operations.empty.subtitle' | i18n }}</span></div
            ></div
          ></ng-template
        >
      </section>
    </ng-template>
  </div>
</section>

<ng-template #drawerTitle>
  <div class="drawer-title-content">
    <h2>{{ (editingApp ? 'assistant.store.drawer.edit-title' : 'assistant.store.drawer.create-title') | i18n }}</h2>
    <p>{{ 'assistant.store.drawer.subtitle' | i18n }}</p>
  </div>
</ng-template>

<ng-template #drawerExtra>
  <button
    nz-button
    nzType="text"
    type="button"
    class="drawer-close-button"
    [disabled]="saving"
    [attr.aria-label]="'common.close' | i18n"
    (click)="closeModal()"
    testId="assistant-store-drawer-close"
  >
    <i nz-icon nzType="close"></i>
  </button>
</ng-template>

<nz-drawer
  [nzVisible]="modalVisible"
  [nzTitle]="drawerTitle"
  [nzExtra]="drawerExtra"
  nzPlacement="right"
  [nzWidth]="640"
  nzWrapClassName="official-assistant-store-drawer"
  [nzClosable]="false"
  (nzOnClose)="closeModal()"
  testId="official-assistant-store-drawer"
>
  <ng-container *nzDrawerContent>
    <form nz-form nzLayout="vertical" [formGroup]="form" class="assistant-form">
      <div class="form-grid">
        <nz-form-item
          ><nz-form-label nzRequired>{{ 'assistant.store.form.name' | i18n }}</nz-form-label
          ><nz-form-control [nzErrorTip]="'assistant.store.validation.name-required' | i18n"
            ><input nz-input formControlName="name" testId="assistant-store-form-name" /></nz-form-control
        ></nz-form-item>
        <nz-form-item
          ><nz-form-label>{{ 'assistant.store.form.provider' | i18n }}</nz-form-label
          ><nz-form-control
            ><input
              nz-input
              [value]="'assistant.store.provider.official' | i18n"
              disabled
              testId="assistant-store-form-provider" /></nz-form-control
        ></nz-form-item>
      </div>
      <nz-form-item
        ><nz-form-label nzRequired>{{ 'assistant.store.form.description' | i18n }}</nz-form-label
        ><nz-form-control [nzErrorTip]="'assistant.store.validation.description-required' | i18n">
          <textarea nz-input rows="3" formControlName="description" testId="assistant-store-form-description"></textarea></nz-form-control
      ></nz-form-item>
      <nz-form-item
        ><nz-form-label>{{ 'assistant.store.form.short-description' | i18n }}</nz-form-label
        ><nz-form-control
          ><input nz-input formControlName="shortDescription" testId="assistant-store-form-short-description" /></nz-form-control
      ></nz-form-item>
      <div class="form-grid"
        ><nz-form-item
          ><nz-form-label nzRequired>{{ 'assistant.store.form.category' | i18n }}</nz-form-label
          ><nz-form-control
            ><nz-select formControlName="category" testId="assistant-store-form-category"
              ><nz-option
                *ngFor="let category of categories"
                [nzValue]="category"
                [nzLabel]="categoryLabel(category)"
                [testId]="'assistant-store-category-option-' + category" /></nz-select></nz-form-control></nz-form-item
        ><nz-form-item *ngIf="form.controls.category.value === 'Custom'"
          ><nz-form-label nzRequired>{{ 'assistant.store.form.custom-category' | i18n }}</nz-form-label
          ><nz-form-control [nzErrorTip]="'assistant.store.validation.custom-category-required' | i18n"
            ><input nz-input formControlName="customCategory" testId="assistant-store-custom-category" /></nz-form-control></nz-form-item
      ></div>
      <div class="icon-version-stack"
        ><nz-form-item testId="assistant-store-icon-field"
          ><nz-form-label nzRequired>{{ 'assistant.store.form.icon' | i18n }}</nz-form-label
          ><nz-form-control
            ><div class="icon-upload-field">
              <div class="icon-preview">
                <img *ngIf="iconPreview; else iconPlaceholder" [src]="iconPreview" [alt]="'assistant.store.form.icon' | i18n" />
                <ng-template #iconPlaceholder><i nz-icon nzType="picture"></i></ng-template>
              </div>
              <div class="icon-upload-actions">
                <label class="icon-upload-button" for="assistant-store-icon-input">
                  <i nz-icon nzType="upload"></i>
                  {{ (iconPreview ? 'assistant.store.form.icon.replace' : 'assistant.store.form.icon.select') | i18n }}
                </label>
                <input
                  id="assistant-store-icon-input"
                  type="file"
                  accept="image/*"
                  (change)="onIconFileChange($event)"
                  testId="assistant-store-icon-input"
                />
                <span>{{ 'assistant.store.form.icon.hint' | i18n }}</span>
              </div>
            </div></nz-form-control
          ></nz-form-item
        ><nz-form-item testId="assistant-store-version-field"
          ><nz-form-label nzRequired>{{ 'assistant.store.form.version' | i18n }}</nz-form-label
          ><nz-form-control
            ><input nz-input formControlName="version" testId="assistant-store-form-version" /></nz-form-control></nz-form-item
      ></div>
      <section class="form-section"
        ><h3>{{ 'assistant.store.section.response' | i18n }}</h3
        ><nz-form-item
          ><nz-form-label nzRequired>Webhook URL</nz-form-label
          ><nz-form-control [nzErrorTip]="'assistant.store.validation.webhook' | i18n"
            ><input
              nz-input
              formControlName="webhookUrl"
              placeholder="https://api.aile.example/webhook/assistant"
              testId="assistant-store-form-webhook-url" /></nz-form-control></nz-form-item
        ><div class="form-grid"
          ><nz-form-item
            ><nz-form-label nzRequired>{{ 'assistant.store.form.response-mode' | i18n }}</nz-form-label
            ><nz-form-control
              ><nz-select formControlName="responseMode" testId="assistant-store-form-response-mode"
                ><nz-option
                  *ngFor="let option of responseModeOptions"
                  [nzValue]="option.value"
                  [nzLabel]="option.labelKey | i18n"
                  [testId]="'assistant-store-response-mode-option-' + option.value" /></nz-select></nz-form-control></nz-form-item></div
        ><section *ngIf="form.controls.responseMode.value === 'Batch'" class="batch-trigger-panel" testId="assistant-store-batch-trigger">
          <div class="batch-trigger-heading">
            <strong>{{ 'assistant.store.batch-trigger.title' | i18n }}</strong>
            <span>{{ 'assistant.store.batch-trigger.description' | i18n }}</span>
          </div>
          <div class="form-grid">
            <nz-form-item
              ><nz-form-label nzRequired>{{ 'assistant.store.batch-trigger.message-count' | i18n }}</nz-form-label
              ><nz-form-control [nzErrorTip]="'assistant.store.batch-trigger.message-count.error' | i18n">
                <input
                  nz-input
                  type="number"
                  min="1"
                  formControlName="batchTriggerMessageCount"
                  testId="assistant-store-batch-trigger-message-count"
                />
                <span class="field-hint">{{ 'assistant.store.batch-trigger.message-count.hint' | i18n }}</span>
              </nz-form-control></nz-form-item
            >
            <nz-form-item
              ><nz-form-label nzRequired>{{ 'assistant.store.batch-trigger.interval-minutes' | i18n }}</nz-form-label
              ><nz-form-control [nzErrorTip]="'assistant.store.batch-trigger.interval-minutes.error' | i18n">
                <input
                  nz-input
                  type="number"
                  min="1"
                  formControlName="batchTriggerIntervalMinutes"
                  testId="assistant-store-batch-trigger-interval-minutes"
                />
                <span class="field-hint">{{ 'assistant.store.batch-trigger.interval-minutes.hint' | i18n }}</span>
              </nz-form-control></nz-form-item
            >
          </div>
          <nz-form-item
            ><nz-form-label>{{ 'assistant.store.batch-trigger.keywords' | i18n }}</nz-form-label
            ><nz-form-control>
              <input
                nz-input
                formControlName="batchTriggerKeywordsText"
                [placeholder]="'assistant.store.batch-trigger.keywords.placeholder' | i18n"
                testId="assistant-store-batch-trigger-keywords"
              />
              <span class="field-hint">{{ 'assistant.store.batch-trigger.keywords.hint' | i18n }}</span>
            </nz-form-control></nz-form-item
          >
        </section></section
      >
      <section class="form-section" testId="assistant-store-scope-section"
        ><h3>{{ 'assistant.store.section.scope' | i18n }}</h3
        ><div class="selection-groups"
          ><div class="selection-block"
            ><label class="selection-label">{{ 'assistant.store.form.message-types' | i18n }}</label
            ><div class="selection-options"
              ><label
                nz-checkbox
                *ngFor="let option of messageTypeOptions"
                [nzChecked]="isOptionSelected('messageTypes', option.value)"
                (nzCheckedChange)="toggleOption('messageTypes', option.value, $event)"
                >{{ option.labelKey | i18n }}</label
              ></div
            ></div
          ><div class="selection-block"
            ><label class="selection-label">{{ 'assistant.store.form.sender-types' | i18n }}</label
            ><div class="selection-options"
              ><label
                nz-checkbox
                *ngFor="let option of senderTypeOptions"
                [nzChecked]="isOptionSelected('senderTypes', option.value)"
                (nzCheckedChange)="toggleOption('senderTypes', option.value, $event)"
                >{{ option.labelKey | i18n }}</label
              ></div
            ></div
          ><div class="selection-block"
            ><label class="selection-label">{{ 'assistant.store.form.reply-receiver-types' | i18n }}</label
            ><div class="selection-options"
              ><label
                nz-checkbox
                [nzChecked]="isOptionSelected('replyReceiverTypes', 'Customer')"
                (nzCheckedChange)="toggleOption('replyReceiverTypes', 'Customer', $event)"
                >{{ 'assistant.store.sender-type.customer' | i18n }}</label
              ></div
            ></div
          ></div
        ></section
      >
      <section class="form-section"
        ><div class="panel-title"
          ><h3>{{ 'assistant.store.section.packages' | i18n }}</h3>
          <button nz-button nzType="link" type="button" (click)="addPackage()" testId="assistant-store-add-package-button"
            ><i nz-icon nzType="plus"></i>{{ 'assistant.store.action.add-package' | i18n }}</button
          ></div
        ><div class="package-list"
          ><div
            class="package-item"
            *ngFor="let package of packageControls.controls; let index = index"
            [formGroup]="$any(package)"
            [testId]="'assistant-store-package-item-' + index"
            ><div class="package-item-header"
              ><strong>{{ 'assistant.store.package.title' | i18n }} {{ index + 1 }}</strong
              ><div class="package-actions"
                ><label class="recommended-option"
                  ><input
                    type="radio"
                    name="recommended-package"
                    [checked]="package.get('recommended')?.value"
                    (change)="setRecommended(index)"
                    [testId]="'assistant-store-package-recommended-' + index"
                  />
                  {{ 'assistant.store.package.recommended' | i18n }}</label
                ><button
                  nz-button
                  nzType="text"
                  nzDanger
                  type="button"
                  [title]="'assistant.store.action.delete-package' | i18n"
                  [attr.aria-label]="'assistant.store.action.delete-package' | i18n"
                  (click)="removePackage(index)"
                  [disabled]="packageControls.length === 1"
                  [testId]="'assistant-store-package-delete-' + index"
                  ><i nz-icon nzType="delete"></i></button></div></div
            ><div class="package-fields"
              ><label class="package-field package-name-field"
                ><span>{{ 'assistant.store.package.name' | i18n }}</span
                ><input
                  nz-input
                  formControlName="name"
                  [placeholder]="'assistant.store.package.name.placeholder' | i18n"
                  [attr.aria-label]="'assistant.store.package.name' | i18n"
                  [testId]="'assistant-store-package-name-' + index" /></label
              ><label class="package-field"
                ><span>{{ 'assistant.store.package.duration' | i18n }}</span
                ><nz-input-group [nzAddOnAfter]="'assistant.store.unit.day' | i18n"
                  ><input
                    nz-input
                    type="number"
                    min="1"
                    formControlName="durationDays"
                    [attr.aria-label]="'assistant.store.package.duration' | i18n"
                    [testId]="'assistant-store-package-duration-' + index" /></nz-input-group></label
              ><label class="package-field"
                ><span>{{ 'assistant.store.package.price' | i18n }}</span
                ><nz-input-group [nzAddOnAfter]="'pricing.package.currency.twd' | i18n"
                  ><input
                    nz-input
                    type="number"
                    min="0"
                    formControlName="priceCny"
                    [attr.aria-label]="'assistant.store.package.price' | i18n"
                    [testId]="'assistant-store-package-price-' + index" /></nz-input-group></label></div></div></div
      ></section>
      <nz-form-item class="feature-tags-field"
        ><nz-form-label>{{ 'assistant.store.form.feature-tags' | i18n }}</nz-form-label
        ><nz-form-control
          ><input
            nz-input
            formControlName="featureTagsText"
            [placeholder]="'assistant.store.form.feature-tags.placeholder' | i18n"
            testId="assistant-store-feature-tags" /></nz-form-control
      ></nz-form-item>
    </form>
    <div class="drawer-footer">
      <button nz-button type="button" (click)="closeModal()" testId="official-assistant-store-modal-cancel-button">{{
        'common.cancel' | i18n
      }}</button>
      <button
        nz-button
        nzType="primary"
        type="button"
        [nzLoading]="saving"
        (click)="save()"
        testId="official-assistant-store-modal-save-button"
        >{{ 'assistant.store.action.save' | i18n }}</button
      >
    </div>
  </ng-container>
</nz-drawer>
